<template>
  <div>
    <div class="relative">
      <div class="flex flex-row items-center">
        <button
          class="btn !pr-1"
          @click="showHoverAddButton = !showHoverAddButton"
        >
          <span class="material-icons-outlined">add</span>
          <span class="material-icons-outlined h-full">expand_more</span>
        </button>
      </div>
      <div
        v-if="showHoverAddButton"
        class="absolute flex flex-col items-start w-1/4 border border-gray-300 rounded-md bg-white !z-10"
      >
        <p
          class="w-full cursor-pointer m-2"
          @click="
            addRecipient();
            showHoverAddButton = false;
          "
        >
          No documents
        </p>
        <hr class="bg-gray-100 w-full" />

        <p
          class="w-full cursor-pointer m-2"
          @click="
            addRecipient('IMR');
            showHoverAddButton = false;
          "
        >
          Invoice response
        </p>
        <hr class="bg-gray-100 w-full" />
        <p
          class="w-full cursor-pointer m-2"
          @click="
            addRecipient('STANDARD_SELECTION');
            showHoverAddButton = false;
          "
        >
          Invoice, Creditnote & Invoice response
        </p>
        <hr class="bg-gray-100 w-full" />
        <p
          class="w-full cursor-pointer m-2"
          @click="
            addRecipient('STANDARD_SELECTION_WITH_MLR');
            showHoverAddButton = false;
          "
        >
          Invoice, Creditnote, Invoice response & MLR
        </p>
      </div>
    </div>

    <div v-for="(item, index) in peppolIdentifiers" :key="index">
      <div class="flex xl:flex-row w-full flex-col">
        <div class="flex flex-row w-2/3 items-center">
          <button
            class="btn size-10 mt-6 mr-2.5"
            @click="removeRecipient(index)"
            v-if="showRemoveRecipient"
          >
            -
          </button>
          <peppol-identifier-selector
            class="basis-full"
            v-model="peppolIdentifiers[index]"
            :show-country="false"
          />
        </div>

        <DropdownSelectAll
          class="xl:ml-4 xl:mt-8 lg:mt-2 w-1/3"
          :id="'documentTypes-' + index"
          :data="this.$store.state.documentTypeIdentifiers"
          :disabled="false"
          :no-select-all="true"
          :selected="item.documents"
          @update-value="updateDocuments($event, index)"
        />
      </div>
      <p v-if="item.error.empty" class="error">
        - The identifier and name may not be empty. Please give the necessary
        information.
      </p>
      <p v-if="item.error.documentRegistration" class="error">
        - If you want to register documents for this identifier, please select
        "Is Receiver".
      </p>
      <p v-if="item.error.senderReceiverSelected" class="error">
        - At least one of "Is Receiver" or "Is Sender" must be selected.
      </p>

      <div
        class="flex flex-row items-center"
        :class="showRemoveRecipient ? 'ml-12' : ''"
      >
        <div class="flex flex-row items-center mr-8">
          <p class="font-bold form-label mt-1.5 mr-2.5">Is receiver:</p>
          <toggle-slide
            @update-value="item.isReceiver = !item.isReceiver"
            :bool="item.isReceiver"
            :key="item.isReceiver"
            :renew-bool="true"
          ></toggle-slide>
        </div>
        <div class="flex flex-row items-center">
          <p class="font-bold form-label mt-1.5 mr-2.5">Is sender:</p>
          <toggle-slide
            @update-value="item.isSender = !item.isSender"
            :bool="item.isSender"
            :key="item.isSender"
            :renew-bool="true"
          ></toggle-slide>
        </div>
      </div>
    </div>

    <button
      id="setReporting"
      class="btn mr-4 mb-4 text-white"
      :style="{ backgroundColor: colors.blue }"
      @click="updatePeppol"
    >
      Add identifiers
    </button>
  </div>
  <UpdateStatusPeppolIdentifier
    v-if="showStatusUpdate"
    :show="showStatusUpdate"
    :statuses="statuses"
    @close="closePopUp"
  />
</template>
<script>
import ToggleSlide from "@/components/ToggleSlide.vue";
import countryCodes from "@/countryCodes";
import PeppolIdentifierSelector from "@/components/AddLegalEntity/peppolIdentifierSelector.vue";
import DropdownSelectAll from "@/components/DropdownSelectAll.vue";
import UpdateStatusPeppolIdentifier from "@/components/ViewLEDetails/componentsPeppolIdentifiers/updateStatusPeppolIdentifier.vue";

export default {
  components: {
    UpdateStatusPeppolIdentifier,
    DropdownSelectAll,
    PeppolIdentifierSelector,
    ToggleSlide,
  },
  props: ["originalIdentifiers"],
  data() {
    return {
      colorSetButton: null,
      colors: { blue: "#291f8d", success: "#91c714", error: "#d32929" },
      createdLeEntityNumber: this.$store.state.activeLE.entityNumber,
      createdLeName: this.$store.state.activeLE.name,
      showHoverAddButton: false,
      peppolIdentifiers: [
        {
          identifier: "",
          name: this.createdLeName,
          countryCode: "BE",
          documents: ["INVOICE_RESPONSE_3_0"],
          isSender: false,
          isReceiver: false,
          error: {
            empty: false,
            documentRegistration: false,
            senderReceiverSelected: false,
          },
        },
        {
          identifier: "",
          name: this.createdLeName,
          countryCode: "BE",
          documents: ["INVOICE_RESPONSE_3_0"],
          isSender: false,
          isReceiver: false,
          error: {
            empty: false,
            documentRegistration: false,
            senderReceiverSelected: false,
          },
        },
      ],
      statuses: [],
      showStatusUpdate: false,
    };
  },
  mounted() {
    const regexBeVatNr = /^BE[0-9]{10}$/;
    const regexCompanyNumber = /[0-9]{10}$/;

    if (regexBeVatNr.test(this.createdLeEntityNumber.toUpperCase())) {
      this.peppolIdentifiers[0].identifier = `0208:${this.createdLeEntityNumber.slice(2)}`;
      this.peppolIdentifiers[1].identifier = `9925:BE${this.createdLeEntityNumber.slice(2)}`;
    } else if (
      regexCompanyNumber.test(this.createdLeEntityNumber.toUpperCase())
    ) {
      this.peppolIdentifiers[0].identifier = `0208:${this.createdLeEntityNumber}`;
      this.peppolIdentifiers[1].identifier = `9925:BE${this.createdLeEntityNumber}`;
    } else this.peppolIdentifiers.pop();

    this.peppolIdentifiers = this.peppolIdentifiers.filter(
      (identifier) => !this.originalIdentifiers.includes(identifier.identifier),
    );
  },
  computed: {
    showRemoveRecipient() {
      return this.peppolIdentifiers.length !== 1;
    },
    isDataValid() {
      return this.peppolIdentifiers.every(
        (id) => !Object.values(id.error).some(Boolean),
      );
    },
  },
  methods: {
    countryCodes() {
      return countryCodes;
    },
    closePopUp() {
      this.showStatusUpdate = false;
      this.statuses.forEach((status) => {
        if (status.status === "success" || status.status === "warning") {
          let object = this.peppolIdentifiers.find(
            (identifier) => identifier.identifier === status.identifier,
          );
          let index = this.peppolIdentifiers.indexOf(object);
          this.peppolIdentifiers.splice(index, 1);
        }
      });
      if (this.peppolIdentifiers.length === 0) this.addRecipient();
      this.statuses = [];
    },
    addRecipient(selectedOption) {
      let documents = [];
      if (selectedOption === "IMR") documents = ["INVOICE_RESPONSE_3_0"];
      else if (
        selectedOption === "STANDARD_SELECTION" ||
        selectedOption === "STANDARD_SELECTION_WITH_MLR"
      ) {
        documents.push(
          "BIS_BILLING_CREDIT_NOTE_V3",
          "BIS_BILLING_INVOICE_V3",
          "INVOICE_RESPONSE_3_0",
        );
      }
      if (selectedOption === "STANDARD_SELECTION_WITH_MLR")
        documents.push("MESSAGE_LEVEL_RESPONSE_3_0");

      this.peppolIdentifiers.push({
        identifier: "",
        name: "",
        countryCode: "BE",
        isReceiver: false,
        isSender: false,
        documents: documents,
        error: {
          empty: false,
          documentRegistration: false,
          senderReceiverSelected: false,
        },
      });
    },
    removeRecipient(index) {
      this.peppolIdentifiers.splice(index, 1);
    },
    updateDocuments(data, index) {
      this.peppolIdentifiers[index].documents = [];
      data.forEach((document) => {
        if (document !== -1) {
          this.peppolIdentifiers[index].documents.push(
            this.$store.state.documentTypeIdentifiers[document].name,
          );
        }
      });
    },
    async registerIdentifier() {
      let payload = {
        sgId: this.$store.state.activeSG.supplierGroupId,
        leId: this.createdLeEntityNumber,
        peppolParticipants: {
          peppolParticipants: { ...this.originalIdentifiers },
        },
      };
      this.peppolIdentifiers.forEach((peppolIdentifier) => {
        if (
          this.statuses.find(
            (status) =>
              status.identifier === peppolIdentifier.identifier &&
              (status.status === "error" || status.status === "warning"),
          ) === undefined
        ) {
          payload.peppolParticipants.peppolParticipants[
            peppolIdentifier.identifier.toLowerCase()
          ] = {
            countryCode: peppolIdentifier.countryCode,
            isReceiver: peppolIdentifier.isReceiver,
            isSender: peppolIdentifier.isSender,
            name: peppolIdentifier.name,
          };
        }
      });

      try {
        await this.$store.dispatch("peppol/addPeppolIdentifier", payload);
        this.peppolIdentifiers.forEach((identifier) => {
          if (
            this.statuses.find(
              (status) => status.identifier === identifier.identifier,
            ) === undefined
          ) {
            this.statuses.push({
              identifier: identifier.identifier,
              status: "success",
              message: "Successfully added",
            });
          }
        });
      } catch (e) {
        this.peppolIdentifiers.forEach((identifier) => {
          if (
            this.statuses.find(
              (status) => status.identifier === identifier.identifier,
            ) === undefined
          ) {
            this.statuses.push({
              identifier: identifier.identifier,
              status: "error",
              message: e.message,
            });
          }
        });
        throw new Error(e.message);
      }
      return;
    },
    validate() {
      this.peppolIdentifiers.forEach((identifier) => {
        identifier.error = {
          empty: !identifier.identifier.trim() || !identifier.name?.trim(),
          documentRegistration:
            identifier.documents.length > 0 && !identifier.isReceiver,
          senderReceiverSelected:
            !identifier.isSender && !identifier.isReceiver,
        };
      });
    },
    async updatePeppol() {
      this.validate();
      if (!this.isDataValid) return;

      this.colorSetButton = null;
      let payload = {
        identifiers: [],
      };

      this.peppolIdentifiers.forEach((identifier) =>
        payload.identifiers.push(identifier.identifier.toLowerCase()),
      );
      await this.$store.dispatch("peppol/getSmpParticipants", payload);

      try {
        await this.registerIdentifier();
      } catch (e) {
        // error is already shown in popup, but process should not continue
        this.showStatusUpdate = true;
        return;
      }
      for (const identifier of this.peppolIdentifiers) {
        try {
          let smpRecords = this.$store.state.smpParticipants.filter(
            (smpP) => identifier.identifier === smpP.identifier,
          );

          if (smpRecords.length === 0 && identifier.documents.length > 0) {
            // Not registered
            let payload = {
              countryCode: identifier.countryCode,
              identifier: identifier.identifier.toLowerCase(),
              name: identifier.name,
              smpProvider: "SMP_NYMUS",
            };
            await this.$store.dispatch(
              "peppol/createPeppolParticipant",
              payload,
            );
          } else if (
            smpRecords[0]?.serviceDescription?.toLowerCase() ===
              "hermes service" &&
            identifier.documents.length > 0
          ) {
            let migrationKey = await this.$store.dispatch(
              "peppol/getHermesMigrationKey",
              identifier.identifier,
            );

            let payload = {
              identifier: identifier.identifier.toLowerCase(),
              migrationKey: migrationKey,
              smpProvider: "SMP_NYMUS",
              name: identifier.name,
              countryCode: identifier.countryCode,
            };
            await this.$store.dispatch("peppol/migrateSmp", payload);
          }

          if (identifier.documents.length > 0) {
            for (const document of identifier.documents) {
              let formData = {
                identifier: identifier.identifier.toLowerCase(),
                smpProvider: "SMP_NYMUS",
                documentTypeIdentifier: document,
              };
              await this.$store.dispatch(
                "peppol/createPeppolDocument",
                formData,
              );
            }
          }

          if (
            Object.keys(this.originalIdentifiers).find(
              (i) => i === identifier.identifier,
            ) !== undefined
          ) {
            if (
              !this.statuses.find((s) => s.identifier === identifier.identifier)
            ) {
              this.statuses.push({
                identifier: identifier.identifier,
                status: "warning",
                message: "This identifier was already added",
              });
            }
          } else
            this.statuses.push({
              identifier: identifier.identifier,
              status: "success",
              message: "Successfully created",
            });
        } catch (e) {
          this.statuses.push({
            identifier: identifier.identifier,
            status: "error",
            message: e.message,
          });
        }
      }
      this.showStatusUpdate = true;
    },
  },
};
</script>

<style>
.error {
  padding: 0 0 !important;
}
</style>
